module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"company_description":"This informations will be used in your company invoice"},"id":{"company_description":"Informasi ini akan digunakan dalam invoice perusahaan"}}')
  delete Component.options._Ctor
}
